import { WorkType } from '@warehouse/title-shared/core';
import { StateCreator } from 'zustand/vanilla';

export interface ParentTitleStore {
	parentTitle: {
		titleUuid: string;
		showHiddenTitles: boolean;
		relationshipType?: string;
		includedWorkTypes?: WorkType[];
	};

	actions: {
		setParentTitle: (value: ParentTitleStore['parentTitle']) => void;
	};
}

export const createFilteringDataSlice: StateCreator<ParentTitleStore> = (set) => ({
	parentTitle: {
		titleUuid: '',
		showHiddenTitles: false,
		relationshipType: undefined,
		includedWorkTypes: [],
	},
	actions: {
		setParentTitle: (value: ParentTitleStore['parentTitle']) => set(() => ({ parentTitle: value })),
	},
});

export const parentTitleStoreSelector = {
	actions: (state: ParentTitleStore) => state.actions,
	parentTitle: (state: ParentTitleStore) => state.parentTitle,
};
